<template>
  <div class="swiper-config-page">
    <div class="d-flex">
      <div class="d-flex">
        <label class="mr5">位置</label>
        <el-select
          class="input200"
          v-model="queryParams.locate"
          clearable
        >
          <el-option
            v-for="item in locateOpts"
            :key="item.id"
            :label="item.title"
            :value="item.id">
          </el-option>
        </el-select>
      </div>

      <div class="d-flex ml20">
        <label class="mr5">名称</label>
        <el-input class="input200" v-model="queryParams.title" clearable />
      </div>

      <el-button
        class="ml20"
        type="primary"
        size="small"
        @click="search"
      >
        查询
      </el-button>
      <el-button
        class="ml10"
        type="primary"
        size="small"
        @click="openNew"
      >
      新增
      </el-button>
    </div>

    <div class="page-card">
      <el-table
        class="mt10"
        border
        @sort-change="sortChange"
        :data="list">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column
          v-for="(item) in headers"
          :key="item.id"
          :type="item.type"
          :label="item.label"
          :prop="item.prop"
          :width="item.width">
          <template slot-scope="scope">
            <template v-if="item.prop === 'locate'">
              {{ locateOpts.find(i => i.id == scope.row.locate) ? locateOpts.find(i => i.id == scope.row.locate).title : '' }}
            </template>
            <template v-else-if="item.prop === 'handle'">
              <el-button
                :disabled="scope.row.status == 2"
                type="text"
                @click="openEdit(scope.row)"
              >
                编辑
              </el-button>

              <!-- <el-button
                type="text"
                @click="openView(scope.row)"
              >
                详情
              </el-button> -->
              <el-button
                :disabled="scope.row.status != 2"
                type="text"
                @click="previewBanners(scope.row)"
              >
                预览
              </el-button>


              <el-button
                :disabled="scope.row.status != 1"
                type="text"
                @click="handleDel(scope.row)"
              >
                删除
              </el-button>
              <el-button
                :disabled="!(scope.row.status == 0 && beforeOrAfter(scope.row.publish_start_time) && !beforeOrAfter(scope.row.publish_end_time))"
                type="text"
                @click="onOrOff(scope.row)"
              >下架</el-button>
              <el-button
                :disabled="!(scope.row.status == 1 && beforeOrAfter(scope.row.publish_start_time) && !beforeOrAfter(scope.row.publish_end_time))"
                type="text"
                @click="onOrOff(scope.row)"
              >上架</el-button>
            </template>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <Edit
      ref="Edit"
      @fresh="getList"
    />

    <BannerPreview
      ref="BannerPreview"
    />
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination';
import {
  pageSize
} from '@/utils/Config.js';
import {
  bannerManage,
  delBanner,
  changeBanner
}  from '@/api.js';
import SwiperMixin from '@/mixins/swiper';
import Edit from './components/Edit.vue';
import BannerPreview from './components/BannerPreview.vue';
export default {
  name: 'SwiperConfigPage',
  components: {
    Pagination,
    Edit,
    BannerPreview
  },
  mixins: [ SwiperMixin ],
  data() {
    return {
      queryParams: {
        locate: 1,
        pageIndex: 1,
        pageSize,
        _total: 0
      },
      headers: [],
      list: []
    }
  },
  methods: {
    // 切换上架或下架的状态
    onOrOff(data){
      this.$request('post',changeBanner,{id:data.id}).then(res=>{
        if(res){
          this.getList()
        }
      })
    },
    getList() {
      const {
        pageIndex,
        pageSize,
        order,
        orderBy,
        locate,
        title
      } = this.queryParams
      const query = {
        per_page: pageSize,
        page: pageIndex,
        order,
        order_column: orderBy,
        locate,
        title
      }

      this.$request('get', bannerManage, query)
      .then(res => {
        if (res) {
          const {
            columns,
            data,
            total
          } = res

          this.list = data
          this.headers = this.$utils.generateColumns(columns)
          this.queryParams._total = total
        }
      })
    },
    search() {
      this.queryParams.pageIndex = 1
      this.getList()
    },
    sortChange(item) {
      // 排序方法
      const { column, order } = item
      const orderString = order ? order === 'ascending' ? 'asc' : 'desc' : undefined
      const orderBy = order ? column.sortBy : undefined

      this.queryParams.order = orderString
      this.queryParams.orderBy = orderBy
      this.getList()
    },
    async handleDel(item) {
      const confirm = await this.$confirm(`确认删除吗?`)
      if (!confirm) return

      const {
        id
      } = item
      const url = delBanner.replace('{id}', id)
      this.$request('post', url)
      .then(res => {
        if (res) {
          this.$message.success(`操作成功`)
          this.getList()
        }
      })
    },
    openNew() {
      const {
        Edit
      } = this.$refs

      Edit && Edit.open()
    },
    openEdit(item) {
      const {
        Edit
      } = this.$refs
      const config = {
        detail: item,
        isView: false
      }


      Edit && Edit.open(config)
    },
    previewBanners(item) {
      const {
        locate,
        id
      } = item
      if (!locate) {
        this.$message.error(`缺少位置信息`)

        return
      }

      const {
        BannerPreview
      } = this.$refs

      BannerPreview && BannerPreview.open(locate, id)
    },
    openView(item) {
      const {
        Edit
      } = this.$refs
      const config = {
        detail: item,
        isView: true
      }


      Edit && Edit.open(config)
    },
    // 判断给定时间是否是在当前时间之后
    beforeOrAfter(data) {
      const currentTime = new Date();
      const compareTime = new Date(data);

      if (compareTime.getTime() < currentTime.getTime()) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.getList()
  }
}
</script>

<style>

</style>